/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { createMatrix } from '../../factoriesNumber.js';
export var matrixDependencies = {
  createMatrix
};